<template>
    <div>
        <b-navbar toggleable="lg">
            <b-navbar-nav>
                <b-nav-item href="#" v-b-toggle.sidebar-backdrop>
                    <i class="fa fa-bars"></i>
                </b-nav-item>
                <b-nav-item class="d-block d-sm-none" href="#" v-b-toggle.sidebar-backdrop1>
                    <i class="fa fa-search"></i>
                </b-nav-item>
                <b-nav-item class="d-none d-sm-block">
                    <form class="form-inline" action="/action_page.php">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <i class="fa fa-search"></i>
                            </div>
                            <input type="text" class="form-control" placeholder="Pesquisar">
                        </div>
                    </form>
                </b-nav-item>
            </b-navbar-nav>

        

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">

                <b-nav-item class="d-block d-sm-none" href="#" v-b-toggle.sidebar-backdrop-notifications>
                    <i class="fa fa-bell"></i><span class="badge bg-primary">3 +</span>
                </b-nav-item>

                <b-nav-item-dropdown class="d-none d-sm-block" no-caret>
                    <template #button-content >
                        <i class="fa fa-bell"></i><span class="badge bg-danger">9 +</span>
                    </template>

                    <b-dropdown-item href="#">
                        <b-row class="mt-md-3">
                                <b-card no-body border-variant="white" img-left>
                                    <b-skeleton-img card-img="left" width="40px"></b-skeleton-img>
                                    <b-card-body>
                                        Nova Notificação
                                    </b-card-body>
                                </b-card>
                        </b-row>
                    </b-dropdown-item>                    <b-dropdown-item href="#">
                        <b-row class="mt-md-3">
                                <b-card no-body border-variant="white" img-left>
                                    <b-skeleton-img card-img="left" width="40px"></b-skeleton-img>
                                    <b-card-body>
                                        Nova Notificação
                                    </b-card-body>
                                </b-card>
                        </b-row>
                    </b-dropdown-item>
                    <b-dropdown-item href="#">
                        <b-row class="mt-md-3">
                            <b-card no-body border-variant="white" img-left>
                                <b-skeleton-img card-img="left" width="40px"></b-skeleton-img>
                                <b-card-body>
                                    Nova Notificação
                                </b-card-body>
                            </b-card>
                        </b-row>
                    </b-dropdown-item>


                    <b-dropdown-item href="#"><b-button block>Ver Todas</b-button></b-dropdown-item>
                </b-nav-item-dropdown>

                <b-nav-item-dropdown no-caret right>
                    <template #button-content>
                    <b-skeleton v-if="!getUser.profile_photo_url" animation="throb" type="avatar"></b-skeleton>
                    <b-img v-else :src="getUser.profile_photo_url" rounded="circle" alt="Circle image"></b-img>
                     
                    </template>
                    <b-dropdown-item href="#">Perfil</b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'logout' }">Sair</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>

        </b-navbar>
    </div>

</template>

<script>



    export default 
    
    
    {
        name: "navbarComponent",
        data() {

            return {
                dropdown: false,
                props: ['sidebarToggled']


            }
        },
computed: {

 getUser(){
     return this.$store.getters.user
 }

},
        methods: {
            lauchDropdown() {
                this.dropdown = !this.dropdown
            },
    
        },
        created() {
            this.$store.dispatch('getUser')
    }
    }

</script>

<style lang="scss" src="./../style.scss" scoped>

</style>